// extracted by mini-css-extract-plugin
export default {"facet-group-title":"facet-group-title_Af_zZ4ZR","mobile-facet-checkbox":"mobile-facet-checkbox_YO3peLa2","facet-checkbox__label":"facet-checkbox__label_sUaR0KOA"};